import React from 'react';

import Contact from '../components/contact/contact';
import Section from '../components/global/section';

export default ({ copy, locations }) => {
	return (
		<Section bg="light">
			<Contact copy={copy} locations={locations} />
		</Section>
	);
};
